import { Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Union } from 'ts-toolbelt';

import { I18nNamespace } from '~/common/types';
import { CircularProgressCentered } from '~/components/CircularProgressCentered/CircularProgressCentered';
import { MaskedBiddingAlert } from '~/components/MaskedBiddingAlert/MaskedBiddingAlert';
import {
  DemandAwardingData,
  DemandAwardingSettings,
  DemandAwardingStatus,
} from '~/modules/DemandAwardingWidget/DemandAwardingWidget.types';

import { useAwardingDataGridConfig } from './AwardingDataGrid.config';
import { DataGridProStyled } from './AwardingDataGrid.styled';

export interface AwardingDataGridProps {
  negotiationCases?: Union.Nullable<DemandAwardingData[]>;
  awardingSettings?: Union.Nullable<DemandAwardingSettings>;
  status?: Union.Nullable<DemandAwardingStatus[]>;
  awardableConfirmedQuotes: boolean;
  isMaskedBidding?: boolean;
  loading?: boolean;
}

export const AwardingDataGrid = ({
  negotiationCases,
  awardingSettings,
  status,
  awardableConfirmedQuotes,
  isMaskedBidding,
  loading,
}: AwardingDataGridProps) => {
  const gridProps = useAwardingDataGridConfig({
    negotiationCases,
    status,
    awardingSettings,
    awardableConfirmedQuotes,
  });
  const { t: tCommon } = useTranslation(I18nNamespace.common, { keyPrefix: 'CompetitiveBidding' });

  // Show spinner while data is retrieved to avoid blips of empty grid in masked bidding mode
  if (loading) {
    return (
      <Stack position="relative" sx={{ height: '100px' }}>
        <CircularProgressCentered />
      </Stack>
    );
  }

  return isMaskedBidding ? (
    <MaskedBiddingAlert message={tCommon('awarding')} sx={{ margin: 4 }} />
  ) : (
    <DataGridProStyled
      treeData
      autoHeight
      loading={loading}
      hideFooter
      // disableColumnResize
      disableColumnMenu
      getRowHeight={() => 'auto'}
      // disableVirtualization
      defaultGroupingExpansionDepth={1}
      {...gridProps}
    />
  );
};
